var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 34,
    viewBox: "0 0 252 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.675614,
    y: 0.675614,
    width: 250.649,
    height: 32.6488,
    rx: 8.33258,
    stroke: "#E2E2E2",
    strokeWidth: 1.35123
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 22,
    width: 154,
    height: 9.99999,
    rx: 4.99999,
    transform: "rotate(-180 168 22)",
    fill: "#EFF0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.987 26.7991H226.564C222.609 26.7991 220.844 25.0335 220.844 21.0789V17.6557C220.844 13.7012 222.609 11.9355 226.564 11.9355H229.266C229.636 11.9355 229.942 12.2418 229.942 12.6112C229.942 12.9805 229.636 13.2868 229.266 13.2868H226.564C223.339 13.2868 222.195 14.4308 222.195 17.6557V21.0789C222.195 24.3038 223.339 25.4478 226.564 25.4478H229.987C233.212 25.4478 234.356 24.3038 234.356 21.0789V18.3764C234.356 18.0071 234.662 17.7008 235.032 17.7008C235.401 17.7008 235.707 18.0071 235.707 18.3764V21.0789C235.707 25.0335 233.942 26.7991 229.987 26.7991Z",
    fill: "#B0B7BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.035 19.0517H232.152C229.621 19.0517 228.594 18.0247 228.594 15.4934V12.6108C228.594 12.3406 228.756 12.0883 229.008 11.9892C229.26 11.8811 229.549 11.9442 229.747 12.1334L235.512 17.8986C235.701 18.0878 235.764 18.3851 235.656 18.6373C235.557 18.8895 235.305 19.0517 235.035 19.0517ZM229.945 14.2413V15.4934C229.945 17.2861 230.359 17.7004 232.152 17.7004H233.404L229.945 14.2413Z",
    fill: "#B0B7BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.771 8.78287H230.168C229.798 8.78287 229.492 8.47659 229.492 8.10726C229.492 7.73792 229.798 7.43164 230.168 7.43164H233.771C234.14 7.43164 234.447 7.73792 234.447 8.10726C234.447 8.47659 234.14 8.78287 233.771 8.78287Z",
    fill: "#B0B7BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.019 11.4853C225.65 11.4853 225.344 11.179 225.344 10.8097C225.344 8.94502 226.857 7.43164 228.722 7.43164H231.082C231.451 7.43164 231.758 7.73792 231.758 8.10726C231.758 8.47659 231.451 8.78287 231.082 8.78287H228.722C227.605 8.78287 226.695 9.6927 226.695 10.8097C226.695 11.179 226.389 11.4853 226.019 11.4853Z",
    fill: "#B0B7BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.004 22.2955C236.634 22.2955 236.328 21.9892 236.328 21.6199C236.328 21.2506 236.634 20.9443 237.004 20.9443C238.031 20.9443 238.859 20.1065 238.859 19.0886V13.5125C238.859 13.1432 239.166 12.8369 239.535 12.8369C239.904 12.8369 240.211 13.1432 240.211 13.5125V19.0886C240.211 20.8542 238.769 22.2955 237.004 22.2955Z",
    fill: "#B0B7BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.534 14.1884H236.831C234.435 14.1884 233.453 13.2065 233.453 10.8103V8.10788C233.453 7.83763 233.615 7.5854 233.868 7.48631C234.12 7.37821 234.408 7.44127 234.606 7.63044L240.011 13.0354C240.2 13.2245 240.263 13.5218 240.155 13.774C240.056 14.0263 239.804 14.1884 239.534 14.1884ZM234.804 9.73836V10.8103C234.804 12.4588 235.183 12.8372 236.831 12.8372H237.903L234.804 9.73836Z",
    fill: "#B0B7BC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 195.846,
    y1: 31.0769,
    x2: 195.846,
    y2: 3.15154,
    stroke: "#DDE4E9",
    strokeWidth: 0.900819,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.f3eb1f6e936d8acae239bf9bdfe15ebd.svg";
export { ForwardRef as ReactComponent };